module.exports = __webpack_public_path__ + "img/kk.3d973b6d.svg";